//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { DataProvider } from '../../helpers/data-provider'
import { Enums } from '../common/enums'

export class OpImrServer implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idImrServer: number
    public standardDescription: string

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdIMRServer
    }
    public getReferenceKey(): number {
        return this.idImrServer
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end
    
    public toString() {
        return this.standardDescription
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idImrServer = opObj.I
                this.standardDescription = opObj.S
                this.opState = opObj.O

            } else {

                this.idImrServer = opObj.ID_IMR_SERVER
                this.standardDescription = opObj.STANDARD_DESCRIPTION
                this.opState = opObj.OpState

            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {

                I: this.idImrServer,
                S: this.standardDescription,
                O: this.opState,

                __IC: 1
            }
        } else {
            return {
                ID_IMR_SERVER: this.idImrServer,
                STANDARD_DESCRIPTION: this.standardDescription,
                OpState: this.opState,
            }
        }
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpImrServer[]): JQueryPromise<OpImrServer[]> {
        var defered = $.Deferred<OpImrServer[]>()

        defered.resolve(list)

        return defered.promise()
    }
}